import { call, takeLatest } from "redux-saga/effects";
import { ADD_APPPROVAL_WORK_FLOW,ADD_DOCUMENTS,ADD_ORIGINATORS,ADD_STAGES,APPROVER_ACTION,GET_ALL_USERS_BY_ROLE_ID, GET_APPROVAL_ACCEPTANCE, GET_APPROVAL_LIST, GET_COLUMNS, GET_MAIN_MODULES, GET_SUB_MODULES } from "../types";
import { addApprovalWorkFlowApi,getAllUsersByRoleIdApi,addStagesApi,getApprovalListApi,getApprovalAcceptanceApi,approverActionApi,addOriginatorsApi, getMainModulesApi, getSubModulesApi, getColumnsApi,addDocumentsApi } from "../apis/approval-workflow-api";
export function* addApprovalWorkFlowWorker(action) {
  try {
    const res = yield call(addApprovalWorkFlowApi, action.data);

    if (res.data?.code === 201) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getAllUsersByRoleIdWorker(action) {
  try {
    const res = yield call(getAllUsersByRoleIdApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* addOriginatorsWorker(action) {
  try {
    const res = yield call(addOriginatorsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getMainModulesWorker(action) {
  try {
    const res = yield call(getMainModulesApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getSubModulesWorker(action) {
  try {
    const res = yield call(getSubModulesApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getColumnsWorker(action) {
  try {
    const res = yield call(getColumnsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* addDocumentsWorker(action) {
  try {
    const res = yield call(addDocumentsApi, action.data);
    if (res.status === 201) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* addStagesWorker(action) {
  try {
    const res = yield call(addStagesApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getApprovalListWorker(action) {
  try {
    const res = yield call(getApprovalListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getApprovalAcceptanceWorker(action) {
  try {
    const res = yield call(getApprovalAcceptanceApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* approverActionWorker(action) {
  try {
    const res = yield call(approverActionApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* addApprovalWorkFlowWatcher() {
  yield takeLatest(ADD_APPPROVAL_WORK_FLOW, addApprovalWorkFlowWorker);
}
export function* getAllUsersByRoleIdWatcher() {
  yield takeLatest(GET_ALL_USERS_BY_ROLE_ID, getAllUsersByRoleIdWorker);
}
export function* addOriginatorsWatcher() {
  yield takeLatest(ADD_ORIGINATORS, addOriginatorsWorker);
}
export function* getMainModulesWatcher() {
  yield takeLatest(GET_MAIN_MODULES, getMainModulesWorker);
}
export function* getSubModulesWatcher() {
  yield takeLatest(GET_SUB_MODULES, getSubModulesWorker);
}
export function* getColumnsWatcher() {
  yield takeLatest(GET_COLUMNS, getColumnsWorker);
}
export function* addDocumentsWatcher() {
  yield takeLatest(ADD_DOCUMENTS, addDocumentsWorker);
}
export function* addStagesWatcher() {
  yield takeLatest(ADD_STAGES, addStagesWorker);
}
export function* getApprovalListWatcher() {
  yield takeLatest(GET_APPROVAL_LIST, getApprovalListWorker);
}
export function* getApprovalAcceptanceWatcher() {
  yield takeLatest(GET_APPROVAL_ACCEPTANCE, getApprovalAcceptanceWorker);
}
export function* approverActionWatcher() {
  yield takeLatest(APPROVER_ACTION, approverActionWorker);
}